export const annualPriceId = import.meta.env.DEV
  ? import.meta.env.VITE_STRIPE_TEST_PRICE_ID
  : import.meta.env.VITE_STRIPE_PRICE_ID;

export const monthlyPriceId = import.meta.env.DEV
  ? import.meta.env.VITE_STRIPE_TEST_MONTHLY_PRICE_ID
  : import.meta.env.VITE_STRIPE_MONTHLY_PRICE_ID;
